import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/KeyboardArrowUp';

class KeyboardArrowUpIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default KeyboardArrowUpIcon;
